const getConfigClientModule = () => {
    let client;

    if (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === undefined) {
        client = require('./configClient/configClientDev');
    }
    if (process.env.REACT_APP_ENV === 'stg') {
        client = require('./configClient/configClientStg');
    }
    if (process.env.REACT_APP_ENV === 'qa') {
        client = require('./configClient/configClientQA');
    }
    if (process.env.REACT_APP_ENV === 'prod') {
        client = require('./configClient/configClientProd');
    }

    return client.default;
};

const getConfigData = () => {
    const ConfigClient = getConfigClientModule();
    const configClient = new ConfigClient();
    const config = configClient.getConfig();

    return config;
};

export default {
    getConfigData,
};
